import React from 'react';
import { Table, Pagination, Form } from 'react-bootstrap';

const CaseTable = ({
  cases,
  totalPages,
  currentPage,
  pageSize,
  sort,
  sortOrder,
  onPageChange,
  onSortChange,
  onPageSizeChange,
  onCaseSelect,
  selectedCaseId
}) => {
  
  // Handle sort change
  const handleSortChange = (field) => {
    if (sort === field) {
      onSortChange(field, sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      onSortChange(field, 'asc');
    }
  };
  
  // Render pagination controls
  const renderPagination = () => {
    const pages = [];
    
    // First page
    pages.push(
      <Pagination.First 
        key="first" 
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      />
    );
    
    // Previous page
    pages.push(
      <Pagination.Prev 
        key="prev" 
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );
    
    // Page numbers
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);
    
    for (let page = startPage; page <= endPage; page++) {
      pages.push(
        <Pagination.Item 
          key={page} 
          active={page === currentPage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Pagination.Item>
      );
    }
    
    // Next page
    pages.push(
      <Pagination.Next 
        key="next" 
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );
    
    // Last page
    pages.push(
      <Pagination.Last 
        key="last" 
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      />
    );
    
    return (
      <div className="d-flex justify-content-between align-items-center my-3">
        <div>
          <Form.Select 
            size="sm" 
            style={{ width: '80px' }} 
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </div>
        <Pagination>{pages}</Pagination>
      </div>
    );
  };
  
  // Column header with sort indicator
  const renderSortableHeader = (label, field) => {
    const isSorted = sort === field;
    return (
      <th 
        className="sortable-header" 
        onClick={() => handleSortChange(field)}
        style={{ cursor: 'pointer' }}
      >
        {label}
        {isSorted && (
          <span className="ms-1">
            {sortOrder === 'asc' ? '▲' : '▼'}
          </span>
        )}
      </th>
    );
  };
  
  return (
    <div className="case-table">
      {/* Table */}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {renderSortableHeader('Case ID', 'case_id')}
            {renderSortableHeader('Customer ID', 'customer_id')}
            {renderSortableHeader('Messages', 'nr_of_messages')}
            {renderSortableHeader('Events', 'nr_of_events')}
            {renderSortableHeader('First Message', 'first_message_ts')}
            {renderSortableHeader('Last Message', 'last_message_ts')}
          </tr>
        </thead>
        <tbody>
          {cases.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center">
                No cases found
              </td>
            </tr>
          ) : (
            cases.map((caseItem) => (
              <tr 
                key={caseItem.case_id}
                onClick={() => onCaseSelect(caseItem.case_id)}
                style={{ 
                  cursor: 'pointer',
                  backgroundColor: selectedCaseId === caseItem.case_id ? '#e7f3ff' : 'transparent'
                }}
                className={selectedCaseId === caseItem.case_id ? 'table-active' : ''}
              >
                <td>{caseItem.case_id}</td>
                <td>{caseItem.customer_id}</td>
                <td>{caseItem.nr_of_messages || 0}</td>
                <td>{caseItem.nr_of_events || 0}</td>
                <td>
                  {caseItem.first_message_ts 
                    ? new Date(caseItem.first_message_ts + 'Z').toLocaleString() 
                    : 'N/A'}
                </td>
                <td>
                  {caseItem.last_message_ts 
                    ? new Date(caseItem.last_message_ts + 'Z').toLocaleString() 
                    : 'N/A'}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      
      {/* Pagination */}
      {totalPages > 0 && renderPagination()}
    </div>
  );
};

export default CaseTable;